function apiBaseUrl() {
  return process.env.REACT_APP_API_BASE_URL;
}

export function user(id) {
  return `${apiBaseUrl()}/api/v2/users/${id}`;
}

export function apiV2UserForgotPasswordUrl() {
  return `${apiBaseUrl()}/api/v2/users/forgot_password`;
}

export function apiV2UserNewResetPasswordUrl() {
  return `${apiBaseUrl()}/api/v2/users/reset_password/new`;
}

export function apiV2UserResetPasswordUrl() {
  return `${apiBaseUrl()}/api/v2/users/reset_password`;
}

export function apiV2AuthenticateUserUrl() {
  return `${apiBaseUrl()}/api/v2/authenticate_user`;
}

export function apiV2ValidateAuthTokenUrl() {
  return `${apiBaseUrl()}/api/v2/validate_auth_token`;
}

export function apiV2TermsAcceptance(user_id) {
  return `${apiBaseUrl()}/api/v2/users/${user_id}/terms_acceptance`;
}



// WEBPACK FOOTER //
// ./src/features/user/apiUrls.js